import React, { Component } from "react";
import { makePaginatedGet } from "@culturehq/client";
import { ModalDialog, PlainButton } from "@culturehq/components";

import { Trans } from "app/utils";

import UserName from "components/common/UserName";

import * as CHQ from "chq";
import ChqModalDialog from "components/common/ChqModalDialog";

type ListCheers = {
  cheers: CHQ.Cheer[];
};

type CheerListModalProps = {
  cheers: CHQ.Cheer[];
  cheersCount: number;
  cheersPath: string;
  children: React.ReactNode;
};

type CheerListModalState = {
  fetchedCheers: null | CHQ.Cheer[];
  open: boolean;
};

class CheerListModal extends Component<CheerListModalProps, CheerListModalState> {
  private componentIsMounted: boolean;

  private fetchCheersTriggered: boolean;

  constructor(props: CheerListModalProps) {
    super(props);

    this.componentIsMounted = false;
    this.fetchCheersTriggered = false;

    this.state = { open: false, fetchedCheers: null };
  }

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  fetchCheers = async () => {
    const { cheersPath } = this.props;
    const { cheers: fetchedCheers } = await makePaginatedGet<ListCheers>("cheers", cheersPath);

    if (this.componentIsMounted) {
      this.setState({ fetchedCheers });
    }
  };

  handleOpen = () => {
    this.setState({ open: true });

    if (!this.fetchCheersTriggered) {
      this.fetchCheersTriggered = true;
      this.fetchCheers();
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { cheers, children, cheersCount } = this.props;
    const { open, fetchedCheers } = this.state;

    return (
      <>
        <PlainButton className="cheers--more" onClick={this.handleOpen}>
          {children}
        </PlainButton>
        {open && (
          <ChqModalDialog className="cheers-modal" onClose={this.handleClose}>
            <ModalDialog.Heading onClose={this.handleClose}>
              <Trans>{cheersCount} Cheers</Trans>
            </ModalDialog.Heading>
            <ModalDialog.Body>
              {(fetchedCheers || cheers).map(({ user }) => (
                <div key={user.id} className="cheers--row chq-grid--row">
                  <div className="chq-grid--col8">
                    <UserName user={user} />
                  </div>
                  <div className="chq-grid--col4">
                    {user.location?.name}
                  </div>
                </div>
              ))}
            </ModalDialog.Body>
          </ChqModalDialog>
        )}
      </>
    );
  }
}

export default CheerListModal;
